import React, { useCallback } from 'react';
import { Modal, Image, Button, Group, Text } from '@mantine/core';
import { Dropzone, FileWithPath, MIME_TYPES } from '@mantine/dropzone';
import { IconPhoto, IconUpload, IconX } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

type ImageUploadModalProps = {
  isEditing: boolean;
  localValue?:string
  value?: string;
  handleDrop: ( files: FileWithPath[]) => void;
  commitEdit: () => void;
  cancelEdit: () => void;
};

const ImageUploadModal = ({ isEditing, value, localValue, handleDrop, commitEdit, cancelEdit }:ImageUploadModalProps ) =>{
  const { t } = useTranslation( 'grid' );

  return (
    <Modal size="lg" opened={isEditing} onClose={cancelEdit} title={t( 'upload_image_modal_title' )} trapFocus={false}>
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '1rem' }}>
        <Image
          radius="sm"
          h={200}
          w="auto"
          fit="contain"
          src={localValue || value || 'https://placehold.co/200x200?text=No+Image'}
        />
      </div>

      <Dropzone
        onDrop={handleDrop}
        onReject={( files ) => console.log( 'rejected files', files )} //TODO: handle reject
        accept={[ MIME_TYPES.png, MIME_TYPES.jpeg ]}
        multiple={false}
        style={{ marginBottom: '1rem' }}
      >
        <Group justify="center" gap="md" style={{ pointerEvents: 'none' }}>
          <Dropzone.Accept>
            <IconUpload size={42} color="var(--mantine-color-blue-6)" stroke={1.5} />
          </Dropzone.Accept>
          <Dropzone.Reject>
            <IconX size={42} color="var(--mantine-color-red-6)" stroke={1.5} />
          </Dropzone.Reject>
          <Dropzone.Idle>
            <IconPhoto size={42} color="var(--mantine-color-dimmed)" stroke={1.5} />
          </Dropzone.Idle>

          <div>
            <Text size="sm" inline>
             {t( 'dropzone_image_title' )}
            </Text>
            <Text size="xs" c="dimmed" inline mt={7}>
              {t( 'dropzone_image_info' )}
            </Text>
          </div>
        </Group>
      </Dropzone>

      <Button style={{ width: '100%' }} onClick={commitEdit}>
        {t( 'upload_image_save_button' )}
      </Button>
    </Modal>
  );
};

export default ImageUploadModal;